import { Redirect, Route } from 'react-router-dom';
import React from 'react';

/**
 * Private Route Component.  Redirects if the user is not logged in
 *
 * @param {Object} props All the properties passed to the React Component.
 * @returns {Element} Stateless functional React component.
 */
const PrivateAdminRouteComponent = ({
  component: Component,
  isLoggedIn = false,
  hasAccountsPermission = false,
  match: { url },
  ...rest
}) => (
  <Route
    {...rest}
    render={(props) => {
      if (!isLoggedIn) return <Redirect to={`${url}/login`} />;
      if (isLoggedIn && hasAccountsPermission) return <Component {...props} />;
      return <Redirect to={`${url}/home`} />;
    }}
  />
);

export default PrivateAdminRouteComponent;



// WEBPACK FOOTER //
// ./src/components/common/PrivateAdminRoute/PrivateAdminRouteComponent.js